module.exports = __webpack_public_path__ + "images/149d79710ec2104e03588af655c6a5fb-logo.png";